import styled from '@emotion/styled';
import React from 'react';

interface Props {
    children: React.ReactNode;
}

export const Layout = ({ children }: Props) => {
    return <Container>{children}</Container>;
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overscroll-behavior-y: contain;
    position: relative;
`;
